var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home animate__animated animate__swing"},[_c('Top'),_c('hr'),_c('Try'),_c('Features')],1)}
var staticRenderFns = []

export { render, staticRenderFns }